// Files uploaded through the admin panel are stored by @adminjs/upload as
// "<itemId>/<filename>" and served by the admin server at
// /files/<type>/<itemId>/<filename>.
//
// Values seeded before the upload feature existed are plain paths into this
// site's own public folder ("/research/motor-drive-control.png") or absolute
// URLs somewhere else, so those are returned untouched.
export const uploadedFileUrl = (type: string, key: string): string => {
  if (!key) return "";
  if (key.startsWith("/")) return key;
  if (/^https?:\/\//i.test(key)) return key;

  const [itemId, ...rest] = decodeURIComponent(key).split("/");
  if (!itemId || rest.length === 0) return "";

  return `${process.env.REACT_APP_CENTRAL_BASE_URL}/files/${type}/${itemId}/${rest.join("/")}`;
};
